// stores/userStore.js
import { defineStore } from "pinia";
import axios from "axios";
import { installApiErrorReporting } from "../helpers/apiErrorReporting";

// This instance is separate from the shared default, so it needs the 5xx
// reporting installed on its own. The session-expiry redirect is installed
// from main.js, which is why the instance is exported.
export const axiosInstance = axios.create();
installApiErrorReporting(axiosInstance);

export const useSubscriptionStore = defineStore("subscription", {
  state: () => ({ subscription: { exists: false } }),
  getters: {},
  actions: {
    async getSubscription(where = "store") {
      const response = await axiosInstance.get("/api/user/subscription");
      //if response.data is null, then subscription does not exist
      if (response.data !== null) {
        this.subscription = response.data;
        this.subscription.exists = true;
      } else {
        this.subscription = { exists: false };
      }
    },
    //function to get session details by id
    async getSessionDetails(id, checkoutProof = null) {
      const response = await axiosInstance.get(
        `/stripe/checkout-session/${encodeURIComponent(id)}`,
        {
          headers: checkoutProof
            ? { "X-Checkout-Success-Proof": checkoutProof }
            : undefined,
          skipAuthRedirect: true,
        }
      );
      return response.data;
    },
    async logout() {
      this.subscription = { exists: false };
      //localStorage.removeItem("subscription");
    },
  },
  persist: true,
});
